<template>
  <div class="w-full height-100">
    <el-dialog
      width="30%"
      title=""
      :visible.sync="isshowAttribute"
      :direction="direction"
      :before-close="handleClose"
    >
      <template slot="title"
        ><h3 class="text-xl mb-0 Add Products text-white">
          Add Attributes
        </h3></template
      >
      <div>
        <div class="px-2">
          <div>
            <p class="fsize14 font-semibold text-4f4f4f mb-0">Attribute Name</p>
            <el-input
              placeholder="Enter or Type..."
              v-model="input"
              class="w-full mt-2"
            ></el-input>
          </div>
        </div>
        <div class="flex justify-center mt-10">
          <vs-button
            @click="handleClick('ecommerce-Addattribute')"
            class="bg-primary text-white font-semibold py-3 fsize14 px-12 sm-fsize14"
          >
            Submit
          </vs-button>
        </div>
      </div>
    </el-dialog>

    <div class="seth-set bg-primary">
      <div
        src="@/assets/images/banh.png"
        class="bg-primary h-100px w-full"
        alt="banh"
      ></div>
      <div class="absolute top-0 py-10 w-full px-6 flex items-center">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Attributes
          </h2>
        </div>
      </div>
    </div>
    <div class="menucontrol-scroll fixed-top">
      <div v-if="EcomAttrinutes">
        <attributeCol :EcomAttrinute="EcomAttrinute" />
      </div>
      <div class="flex justify-center py-20">
        <div class="text-center">
          <div v-if="!EcomAttrinutes">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Assets/file.svg"
              alt="image"
              class="w-4/5"
            />
            <h6 class="text-black foont-semibold mt-1 text-xl text-center">
              No Data Found
            </h6>
          </div>
          <!-- <div class="flex justify-center mt-6">
          <button
            class="bg-primary text-white fsize14 px-6 py-3 border-0 rounded-full"
            @click="isshowAttribute = true"
          >
            Add Attributes
          </button>
        </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import attributeCol from "./components/Attributecol.vue";
export default {
  data() {
    return {
      isshowAttribute: false,
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },

    getAttribute() {
      this.$store.dispatch("EcomAttributes/getAttributes");
    },
  },
  mounted() {
    this.getAttribute(), console.log(this.EcomAttrinutes);
  },
  computed: {
    ...mapState("EcomAttributes", ["EcomAttrinutes"]),
  },
  components: {
    attributeCol,
  },
};
</script>
